import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { cn } from '../../lib/utils';
interface MiniFAQProps {
  heading?: string;
  items: {
    q: string;
    a: string;
  }[];
}
export function MiniFAQ({
  heading = 'Common questions',
  items
}: MiniFAQProps) {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="px-5 md:px-6 py-10 md:py-14 bg-surface" data-id="element-515" data-mp="1p6q80pjyrlvh">
      <div className="max-w-3xl mx-auto" data-id="element-516" data-mp="1u5knbhiq2sau">
        <h2 className="font-serif text-3xl md:text-[2.6rem] text-ink leading-tight mb-6 md:mb-8" data-id="element-517" data-mp="1u4j9x6e8htpy">
          {heading}
        </h2>
        <div className="space-y-3" data-id="element-518" data-mp="1z5yy37bpkgck">
          {items.map((item, i) => {
          const isOpen = open === i;
          return <div key={item.q} className="rounded-2xl border border-border bg-background overflow-hidden" data-id="element-519" data-mp="2852gsa6yqtqj" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 min-h-[44px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-inset" data-id="element-520" data-mp="8u2qxfn1qfwh">
                  <span className="font-serif text-xl text-ink" data-id="element-521" data-mp="1cepe5din27a4">{item.q}</span>
                  <Plus className={cn('w-5 h-5 text-accent shrink-0 transition-transform duration-300 ease-soft', isOpen && 'rotate-45')} data-id="element-522" data-mp="17f31p6amwv2d" />
                </button>
                <div className={cn('grid transition-all duration-300 ease-soft', isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0')} data-id="element-523" data-mp="201dzyaarqjw0">
                  <div className="overflow-hidden" data-id="element-524" data-mp="jmmb27ctzurg">
                    <p className="px-6 pb-5 text-muted-ink leading-relaxed" data-id="element-525" data-mp="eoulvl3kmmqy">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}